import { Box } from '@mui/material';
import { useState } from 'react';

import { HeaderNavi } from '@/components/Header';
import { SideMenu } from '@/components/SideMenu';

type MainLayoutProps = {
  children: React.ReactNode;
};

export const MainLayout = (props: MainLayoutProps) => {
  const { children } = props;
  const [isSideMenuOpen, setIsSideMenuOpen] = useState(true);

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', height: '100vh', overflow: 'hidden' }}>
      <HeaderNavi isSideMenuOpen={isSideMenuOpen} onToggleSideMenu={() => setIsSideMenuOpen((prev) => !prev)} />
      <Box
        id="main-layout-area"
        sx={{
          '--side-menu-width': isSideMenuOpen ? '240px' : '0px',
          display: 'flex',
          flex: 1,
          minHeight: 0,
          overflow: 'hidden',
          background: '#FFFFFF',
        }}
      >
        <SideMenu isOpen={isSideMenuOpen} />
        <Box id="content-layout-area" sx={{ flex: 1, minWidth: 0, minHeight: 0, overflowY: 'auto' }}>
          <Box component="main" sx={{ height: '100%', width: '100%' }}>
            {children}
          </Box>
        </Box>
      </Box>
    </Box>
  );
};
